import styled from 'styled-components'
import YoutubePlayer from '../YoutubePlayer'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`

export const StyledYoutubePlayer = styled(YoutubePlayer)`
    margin: auto;
`